import React from 'react';
import JobMatchIcon from 'app/assets/images/suitcase-blue.svg';
import JobMatchGreyIcon from 'app/assets/images/suitcase-grey.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { RouteParams } from '../../../Profile/CandidateProfile';
import { useDispatch, useSelector } from 'react-redux';
import { getCandidateOrderMatchActions } from '../../OrderMatchTab/store/candidateOrderMatch.redux';
import { gridStateActions } from 'app/components/Common/Grid/GridStateManagement/GridState.redux';
import { initialFilterChips } from '../../OrderMatchTab/store/candidateOrderMatch.redux';
import { GridCellParams } from '@mui/x-data-grid-pro';
import { Badge } from '@mui/material';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import { selectUser } from 'oidc/user.selectors';
import { jobPreferncesActions } from '../store/JobPreferences.redux';
import { candidateDetailsSelection } from '@AMIEWEB/Candidate/CandidateProfile/Profile/CandidateDetails.selector';
import { useDecision } from '@optimizely/react-sdk';
import { ff_candidate_ui_preferences, ff_WorkExperience_Enhancement } from 'app/constants/FeatureFlags/Candidate/Keys';
import { getEmployeeId } from '@AMIEWEB/Notification/Tasks/Common_v2/utils';

export const JobMatchesXgridCell = (params: GridCellParams) => {
  /** Memoization prevents first level component from using hooks */
  return <JobMatchesXgrid params={params} />;
};

const JobMatchesXgrid = ({ params }: { params: GridCellParams }) => {
  const { userInfo } = useSelector(selectUser);
  const history = useNavigate();
  const candidateDetails = useSelector(candidateDetailsSelection);
  const [enableJobPreferences] = useDecision(ff_candidate_ui_preferences);
  const [hasWorkExperienceTab] = useDecision(ff_WorkExperience_Enhancement);
  const assignedRecruiter = candidateDetails.recruiter.recruiterId;
  const jobMatchCount = params?.row?.jobMatches || 0;
  const routeParams = useParams() as unknown as RouteParams;
  const candidateId = routeParams.travelerId;
  const brandId = routeParams.brandId;
  const preferenceId = params.row.id;
  const dispatch = useDispatch();
  const newJobMatchCount = params?.row?.alertsSent - params?.row?.alertsSeen;
  const checkAssignedRecruiter = parseInt(getEmployeeId(userInfo)) === assignedRecruiter;

  const redirecttoCandidate = () => {
    let redirectTabNumber = 5;
    if (enableJobPreferences?.enabled && hasWorkExperienceTab?.enabled) {
      redirectTabNumber = 7;
    } else if (
      (enableJobPreferences?.enabled && !hasWorkExperienceTab?.enabled) ||
      (!enableJobPreferences?.enabled && hasWorkExperienceTab?.enabled)
    ) {
      redirectTabNumber = 6;
    } else if (!enableJobPreferences?.enabled && !hasWorkExperienceTab?.enabled) {
      redirectTabNumber = 5;
    }
    setTimeout(() => {
      if (!window.location.href.includes(`/candidate/${candidateId}/${brandId}?tab=${redirectTabNumber}`)) {
        history(`/candidate/${candidateId}/${brandId}?tab=${redirectTabNumber}`);
      }
    }, 1000);
  };

  const onLinkClicked = () => {
    setPreferences();
    redirecttoCandidate();
  };

  const setPreferences = React.useCallback(() => {
    dispatch(getCandidateOrderMatchActions.setId(preferenceId));
    dispatch(getCandidateOrderMatchActions.setChips(initialFilterChips));
    dispatch(gridStateActions.setFilterAttributes({ filterObject: Object.entries(initialFilterChips) }));
    dispatch(
      jobPreferncesActions.getJobPreferencesAction({
        travelerId: candidateDetails.travelerId,
        brandId: candidateDetails.brandId,
      }),
    );
  }, [preferenceId, dispatch]);

  return (
    <div>
      {jobMatchCount > 0 ? (
        <div style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={onLinkClicked}>
          {newJobMatchCount > 0 && checkAssignedRecruiter ? (
            <div style={{ display: 'flex' }}>
              <img src={JobMatchIcon} alt="" />
              <Badge color="error" variant="dot">
                <CustomTooltip
                  tooltipContent={`${newJobMatchCount + (newJobMatchCount > 1 ? ' new jobs' : ' new job')}`}
                >
                  <p style={{ margin: '2px', color: '#0D76BC' }}>{jobMatchCount}</p>
                </CustomTooltip>
              </Badge>
            </div>
          ) : (
            <div style={{ display: 'flex' }}>
              <img src={JobMatchIcon} alt="" />
              <p style={{ margin: '2px', color: '#0D76BC' }}>{jobMatchCount}</p>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: 'flex' }}>
          <img src={JobMatchGreyIcon} alt="" color="#C7C7C7" />
          <p style={{ margin: '2px', color: '#C7C7C7' }}>{jobMatchCount}</p>
        </div>
      )}
    </div>
  );
};
